import React from 'react';

import Chip from '@mui/material/Chip';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import withStyles from '@mui/styles/withStyles';
import { History } from 'history';

import { red, common } from '@mui/material/colors';

const red500 = red['500'];
const { white } = common;

const styles = () => ({
  root: {
    backgroundColor: red500,
    color: white,
    margin: '0 auto',
  },
});

type ErrorProps = {
  text: string | null;
  classes: { root: string };
};

export const Error = withStyles(styles)(({ text, classes }: ErrorProps) => (
  <Chip role="alert" className={classes.root} label={text} />
));

type SnackbarErrorProps = {
  text: string;
  classes: { root: string };
  action: string;
};

export const SnackbarError = withStyles(styles)(({ text, classes, action }: SnackbarErrorProps) => (
  <Snackbar open>
    <SnackbarContent className={`${classes.root} message`} message={text} action={action} />
  </Snackbar>
));

export const GoBack = (history: History, defaultUrl: string): void => {
  if (history.length > 2) {
    history.goBack();
  } else {
    history.push(defaultUrl);
  }
};
